export const DEFAULT_SITE_SCALE = 0.5;
export const NO_ZOOM_SCALE = 1;
export const MAX_SITE_SCALE = 1;
export const MIN_SITE_SCALE = 0.2;
